import './style.scss'
import { CommunitiesResultProfile } from '../../server/types'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { LazyLoadImage } from 'react-lazy-load-image-component'

interface AppCommunityResultProfileProps {
	profile: CommunitiesResultProfile
}

function AppCommunityResultProfile({profile}: AppCommunityResultProfileProps) {
	
	return (
		<div
			className="app-community-profile-wrap"
		>
			<a
				href={`${PAGE_URLS.APP_COMMUNITY}`}
				aria-label={`Visit the profile page for Instructor ${profile.name}`}
			>
				<LazyLoadImage
					className='app-seach-result-profile-img'
					// src={'/imgs/temp/community/temp-icon.png'}
					src={profile.profile_pic}
					alt='Community Profile'
					loading="lazy"
					fetchPriority='high'
				/>
			</a>
			<div
				className='app-community-item-name-overlay'
			>
				<div className='app-community-item-name'>{profile.name}</div>
			</div>
		</div>
	)
}

export default AppCommunityResultProfile
